import styled from "styled-components";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";

export const PrizeValueCasino777Box = styled.div`
    font-size: 3.2rem;
    font-weight: 900;
    color: ${baseColors.base04Contrast};

    @media ${({theme}) => theme.mediaQuery.portrait} {
        text-align: center;
    }
`;